module.exports = __webpack_public_path__ + "static/img/fu_tit01.7295c10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/fu_tit01.png
// module id = 115
// module chunks = 6